import { types as t } from '@invisr/mobx-state-tree'
import crudActions from './crud-actions'
import JSONProvider from './JsonProvider'

export default t
  .model('JsonConfig', {
    type: t.optional(t.string, 'JSON'),
    json: t.maybeNull(t.string)
  })
  .views(self => ({
    get provider () {
      return JSONProvider
    }
  }))
  .views(self => ({
    getFields () {
      let fields = []
      let jsonData = JSON.parse(self.json)
      let item = Array.isArray(jsonData) ? jsonData[0] : jsonData
      if (!item) return
      for (let key in item) {
        // take only primitives
        if (Object(item[key]) !== item[key]) {
          fields.push({
            createable: false,
            editable: false,
            fieldPath: key,
            isNameField: false,
            label: key,
            readable: true,
            sobjectAPIName: 'JSON',
            type:
              typeof item[key] === 'number'
                ? 'DECIMAL'
                : (typeof item[key]).toUpperCase()
          })
        }
      }
      return fields
    },
    labels () {
      let childNodes = []
      try {
        childNodes = labelJson(JSON.parse(self.json)) || []
      } catch (e) {
        console.log(e)
      }

      return {
        key: (self as any).id as string,
        label: (self as any).name as string,
        childNodes: [
          {
            key: 'data',
            label: 'Data',
            isExpanded: false,
            childNodes
          }
        ]
      }
    }
  }))
  .actions(crudActions)

function labelJson (json) {
  let childNodes
  if (json && typeof json === 'object') {
    let nodes = json
    if (Array.isArray(json)) {
      if (json.length > 0) {
        json = json[0]
        nodes = json
      } else {
        nodes = {}
      }
    }
    nodes = Object.entries(nodes)

    childNodes = nodes.map(([k, v]) => ({
      key: k,
      label: k,
      fieldType: typeof v,
      meta: {
        label: k
      },
      isExpanded: false,
      childNodes: labelJson(json[k])
    }))
  }
  return childNodes
}
